import { GetBoInvestorProfileIdEndpoint } from '@Common/types/bo/b2b/investor_profile';

const investorProfileFields: Record<
  keyof GetBoInvestorProfileIdEndpoint['Client']['ResponseBody'],
  string
> = {
  id: 'Profile ID',
  b2b_contract_id: 'Contract ID',
  allocation_instruments: 'Number of funds',
  allocations: 'Allocation',
  name: 'Profile name',
  plan_category: 'Plan',
  plan_ids: 'Plan ID(s)',
  risk_profile: 'Risk profile',
};

export const b2bInvestorProfileTranslations = {
  fields: investorProfileFields,
  list: {
    allocation_nbr: 'Number of funds',
    plan_category: 'Plan',
    plan_ids: 'Plan ID(s)',
    empty: 'This company has no investor profiles yet',
  },
  risk_profile: {
    balanced: 'Balanced',
    careful: 'Cautious',
    dynamic: 'Dynamic',
    sicav: 'SICAV retirement',
  },
  create: {
    title: 'Create investment profile',
    product_category: 'Product Category',
    name: 'Profile name',
    template: 'Investment profile template',
    grid_configuration: {
      title: 'Profile configuration',
      subtitle: 'Use the filters to select the recipient group',
      add_assets: 'Add assets',
      years_before_retirement: 'Years before retirement',
    },
    sicav_grid_configuration: {
      retirement_year: 'Retirement year',
      placement_support: 'Placement support',
      instrument_placeholder: 'Add asset',
      add_row: 'Add row',
    },
  },
  menu: {
    investor_profile: 'Investor Profile',
  },
};
